import { render } from "./ListeAvis.vue?vue&type=template&id=1707c1f0&ts=true"
import script from "./ListeAvis.vue?vue&type=script&lang=ts"
export * from "./ListeAvis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__